import {
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
  Card,
  CardBody,
} from "@nextui-org/react";
import { Loader2 } from "lucide-react";
import {
  useGetWalletCheck,
  useGetWalletUserList,
} from "@/services/admin-wallet.service";

const DepositsManagement = () => {
  // Get wallet stats and user list data
  const { data: walletCheck, isLoading: isLoadingStats } = useGetWalletCheck();
  const { data: userList, isLoading: isLoadingUsers } = useGetWalletUserList();

  // Loading state
  if (isLoadingStats || isLoadingUsers) {
    return (
      <div className="flex items-center justify-center p-8">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  const stats = walletCheck?.data;
  const users = userList?.data || [];

  // Table columns configuration
  const columns = [
    {
      key: "userName",
      label: "Username",
    },
    {
      key: "email",
      label: "Email",
    },
    {
      key: "wallet",
      label: "Wallet Address",
    },
    {
      key: "chain",
      label: "Chain",
    },
  ];

  return (
    <div className="flex flex-col p-8">
      <div className="font-ubuntu float-left text-center text-2xl  font-semibold text-white sm:text-lg">
        <p className="hidden sm:block">Deposit Wallet Management</p>
      </div>

      {/* Stats Cards */}
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <Card className="bg-white/10">
          <CardBody>
            <p className="text-lg text-white">Total Users</p>
            <p className="text-2xl font-bold text-white">
              {stats?.totalUsers || 0}
            </p>
          </CardBody>
        </Card>
        <Card className="bg-white/10">
          <CardBody>
            <p className="text-lg text-white">Total Wallets</p>
            <p className="text-2xl font-bold text-white">
              {stats?.totalWallets || 0}
            </p>
          </CardBody>
        </Card>
        <Card className="bg-white/10">
          <CardBody>
            <p className="text-lg text-white">Available Wallets</p>
            <p className="text-2xl font-bold text-white">
              {stats?.availableWallets || 0}
            </p>
            {!stats?.isEnoughWallets && (
              <p className="mt-2 text-sm text-red-500">
                Need {stats?.needMoreWallets} more wallets
              </p>
            )}
          </CardBody>
        </Card>
      </div>

      {/* User List Table */}
      <div className="mt-8 w-full">
        <div className="w-full overflow-x-auto">
          <Table
            removeWrapper
            className="table-striped table-striped-even table"
          >
            <TableHeader className="rounded-none" columns={columns}>
              {(column) => (
                <TableColumn key={column.key}>
                  <div className="white-op flex">{column.label}</div>
                </TableColumn>
              )}
            </TableHeader>
            <TableBody items={users}>
              {(item) => (
                <TableRow key={item.userId}>
                  {(columnKey) => (
                    <TableCell>
                      {(() => {
                        if (columnKey === "wallet") {
                          return (
                            <div>
                              {item.wallet?.address || "No wallet assigned"}
                            </div>
                          );
                        }
                        if (columnKey === "chain") {
                          return <div>{item.wallet?.chain || "-"}</div>;
                        }
                        const value = item[columnKey as keyof typeof item];
                        return <div>{String(value)}</div>;
                      })()}
                    </TableCell>
                  )}
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default DepositsManagement;
